import { Loadable } from "@rentiohq/web-shared-next/dist/ui-components/Loadable";
import { lazy } from "react";
const Applications = Loadable(lazy(() => import("../scenes/Applications")));
const BankAccount = Loadable(lazy(() => import("../scenes/BankAccount")));
const Chats = Loadable(lazy(() => import("../scenes/Chats")));
const Contacts = Loadable(lazy(() => import("../scenes/Contacts")));
const Dashboard = Loadable(lazy(() => import("../scenes/Dashboard")));
const KnowYourCustomer = Loadable(lazy(() => import("../scenes/Kyc")));
const Sca = Loadable(lazy(() => import("../scenes/Sca")));
const Payments = Loadable(lazy(() => import("../scenes/Payments")));

export const PrivateRoutes = [
  {
    path: "",
    element: <Dashboard />,
  },
  {
    path: "applications",
    element: <Applications />,
  },
  {
    path: "chats",
    element: <Chats />,
  },
  {
    path: "chats/:chatId",
    element: <Chats />,
  },
  {
    path: "contacts",
    element: <Contacts />,
  },
  {
    path: "payments",
    element: <Payments />,
  },
  {
    path: "kyc",
    element: <KnowYourCustomer />,
  },
  {
    path: "sca",
    element: <Sca />,
  },
  {
    path: "bank-account",
    element: <BankAccount />,
  },
];
